const entries = Object.entries;
const keys = Object.keys;
const values = Object.values;
const filterByKey = (o, predicate) => {
  return Object.fromEntries(entries(o).filter(([k]) => predicate(k)));
};
const filterByValue = (o, predicate) => {
  return Object.fromEntries(entries(o).filter(([, v]) => predicate(v)));
};

export { entries, filterByKey, filterByValue, keys, values };
//# sourceMappingURL=object.mjs.map
